import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Amplify from '@aws-amplify/core'
import AwsExports from '@/assets/aws-exports'
import VueGoogleCharts from 'vue-google-charts'
import VueClipboard from 'vue-clipboard2'

declare var global: any
Amplify.configure(AwsExports)

Vue.use(VueGoogleCharts)
Vue.use(require('vue-moment'))
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
